// extracted by mini-css-extract-plugin
module.exports = {"amounts":"Amounts_amounts__25DM-","spent":"Amounts_spent__3jwYG"};